import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import EmptyImage from 'src/assets/images/empty-clipboard.svg'
import EmptySearchImage from 'src/assets/images/empty-search.svg'

interface Props {
  isSearchUsed: boolean
}

const EmptyDocumentReviewQueueComponent = ({ isSearchUsed }: Props) => {
  return (
    <div
      data-testid="document-review-queue-empty"
      css={tw`flex h-full flex-1 flex-col items-center justify-center`}
    >
      <img src={isSearchUsed ? EmptySearchImage : EmptyImage} alt="" />
      <Typography variant="h4" css={tw`mb-1 mt-2 font-semibold`}>
        {isSearchUsed ? 'No documents found' : 'Nothing waiting for review'}
      </Typography>
      <Typography variant="body2" css={tw`text-shades-400`}>
        {isSearchUsed
          ? 'Please try a different search query.'
          : 'Documents appear here as contractors submit them.'}
      </Typography>
    </div>
  )
}

export const EmptyDocumentReviewQueue = memo(EmptyDocumentReviewQueueComponent)
